module.exports = __webpack_public_path__ + "img/amazing-meter.cf1f2ee5.svg";